import React, { useEffect, useState, lazy, Suspense, useRef } from "react";
import { API_BASE_URL, Assets_URL } from "../../../../Apicongfig";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSidebarContext } from "../../../../../context/SidebarContext";
import moment from "moment";
import { FaExpand } from 'react-icons/fa';  // Import the FaExpand icon
import { PiFilePdfLight } from "react-icons/pi";
import { IoCopyOutline, IoVideocamOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import {
  convertCount2ToSeconds,
  convertTimeTakenToSeconds,
  formatPauseTime,
  formatStepDate,
  getTimeUnitDisplay,
} from "../../../../Utils/MeetingFunctions";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { HiUserCircle } from "react-icons/hi2";
import {
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdOutlinePhotoSizeSelectActual,
} from "react-icons/md";
import { toast } from "react-toastify";
import { RiFileExcel2Line } from "react-icons/ri";
import Spreadsheet from "react-spreadsheet";
import { read, utils } from "xlsx";
import DOMPurify from "dompurify";
import { useRecording } from "../../../../../context/RecordingContext";
import ConfirmationModal from "../../../../Utils/ConfirmationModal";
import { StepCounterContextProvider, useStepCounterContext} from "../../context/StepCounterContext";
const LazyStepChart = lazy(() => import("../../CreateNewMeeting/StepChart"));

const StepCard = ({
  data,
 
  users,
  meeting,
  refreshMeeting,
}) => {
  const { setSelectedStep } = useStepCounterContext();

  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { toggle, show } = useSidebarContext();
  const [stepId, setStepId] = useState(null);
  const [stepIndex, setStepIndex] = useState(null);
  const [isDrop, setIsDrop] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [inProgressStep, setInProgressStep] = useState(null);
  const handleCloseModal = () => {
    setIsModalOpen(!isModalOpen);
    toggle(true);
  };
  const [loading, setLoading] = useState(false);



  const [visoModal, setVisioModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [step, setStep] = useState(null);

  const handleConfirm = () => {
    setVisioModal(false);
    if (selectedItem) {
      setTimeout(() => {
        const newTab = window.open(
          selectedItem?.meet_link,
          "_blank",
          "noopener,noreferrer"
        );

        if (!newTab) {
          console.error("Popup blocked! The new tab could not be opened.");
        } else {
          newTab.focus(); // Bring the new tab to the front after 5 seconds
        }
      }, 5000); // 5-second delay
    }
    continueChangeStatusAndPlay(selectedItem, step);
  };

  const handleClose = () => {
    setVisioModal(false);
    setSelectedItem(null);
    continueChangeStatusAndPlay(selectedItem, step);
  };
  const changeStatusAndPlay = async (item, step) => {
    const loggedInUserId = sessionStorage.getItem("user_id"); // Get the logged-in user's ID from session storage
    setStep(step);

    continueChangeStatusAndPlay(item, step);
  };
  const continueChangeStatusAndPlay = async (item, step) => {
    setSelectedStep(step);

    navigate(`/actīon-play/${item?.id}/${step?.id}`);
      };

  const localizeTimeTaken = (timeTaken) => {
    if (!timeTaken) return;

    // Retrieve localized time units
    const timeUnits = t("time_unit", { returnObjects: true });

    // Split timeTaken string by spaces and iterate over each segment
    return timeTaken
      .split(" ")
      .map((part) => {
        // Check if the part is numeric or text
        if (!isNaN(part)) {
          return part; // Return the number as is
        }
        // Otherwise, it's a unit; look up its localized version
        return timeUnits[part] || part; // Fallback to original if no localization
      })
      .join(" ");
  };

  const convertTo24HourFormat = (time, date, type, timezone) => {
    if (!time || !date || !type) {
      return false;
    }

    const meetingTimezone = timezone || "Europe/Paris";
    const userTimezone = moment.tz.guess();

    // Convert meeting time from its original timezone to the user's timezone
    const convertedTime = moment
      .tz(`${date} ${time}`, "YYYY-MM-DD HH:mm:ss A", meetingTimezone)
      .tz(userTimezone);

    // Assuming time is in 'hh:mm:ss A' format (12-hour format with AM/PM)
    // const timeMoment = moment(time, "hh:mm:ss A");
    // return timeMoment.isValid() ? timeMoment.format("HH:mm:ss") : "";
    // Assuming time is in 'hh:mm:ss A' format (12-hour format with AM/PM)
    const timeMoment = moment(convertedTime, "hh:mm:ss A");

    // Check if the time is valid
    if (!timeMoment.isValid()) return "";

    // If the meeting type is 'Quiz', include seconds in the format
    const format = type === "seconds" ? "HH[h]mm[m]ss" : "HH[h]mm";

    // Return the time in the appropriate format
    return timeMoment.format(format);
  };

  const localizeTimeTakenActive = (timeTaken) => {
    if (!timeTaken) return "";

    // Retrieve localized time units
    const timeUnits = t("time_unit", { returnObjects: true });

    // Split the timeTaken string by " - " to separate time components
    const timeParts = timeTaken.split(" - ");

    // Initialize variables for each time component
    let days = null;
    let hours = null;
    let minutes = null;
    let seconds = null;

    // Iterate over each part and assign it to the corresponding variable
    timeParts.forEach((part) => {
      if (part.includes("day")) {
        days = part;
      } else if (part.includes("hour")) {
        hours = part;
      } else if (part.includes("min")) {
        minutes = part;
      } else if (part.includes("sec")) {
        seconds = part;
      }
    });

    // Check if days are present
    const hasDays = Boolean(days);

    // Determine what to show based on the presence of days
    let result = "";
    if (hasDays) {
      // Show days and hours if days are present
      result = [days, hours].filter(Boolean).join(" - ");
    } else if (hours) {
      // Show only hours and minutes if hours and minutes are present
      result = [hours, minutes].filter(Boolean).join(" - ");
    } else if (minutes) {
      // Show minutes only if no days or hours are present
      // result = minutes;
      result = [minutes, seconds].filter(Boolean).join(" - ");
    } else {
      result = seconds;
    }

    // Return empty string if result is undefined or empty
    if (!result) return "";

    // Localize and return the result
    return result
      .split(" ")
      .map((part) => (isNaN(part) ? timeUnits[part] || part : part))
      .join(" ");
  };

  const [items, setItems] = useState(data); // Store the items in the state
  const [isDrag, setIsDrag] = useState(false);
  const onDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    const draggedStep = items[result.source.index];
    const destinationStep = items[result.destination.index];

    // Prevent drag if status is 'in_progress'
    if (
      draggedStep?.step_status === "in_progress" ||
      draggedStep?.step_status === "completed"
    ) {
      console.log("Cannot drag steps with 'in_progress' status.");
      return;
    }

    // Prevent moving any step before a 'completed' step
    if (
      destinationStep?.step_status === "completed" &&
      draggedStep?.step_status !== "completed"
    ) {
      return;
    }

    // Prevent placing a 'completed' step after an 'upcoming' or 'in_progress' step
    if (
      draggedStep?.step_status === "completed" &&
      (destinationStep?.step_status === null ||
        destinationStep?.step_status === "in_progress")
    ) {
      return;
    }

    // Prevent placing a step with 'null' status before an 'in_progress' step
    if (
      draggedStep?.step_status === null &&
      destinationStep?.step_status === "in_progress"
    ) {
      return;
    }

  // 🛠️ Make deep copy BEFORE reorder
  const originalItems = items.map(item => ({ ...item }));

  const reorderedItems = reorder(items, result.source.index, result.destination.index);

  // ✅ Compare with original copy
  const changedSteps = reorderedItems.filter((step, index) => {
    return step.id !== originalItems[index].id;
  });

setItems(reorderedItems);
setIsDrag(true);

// Call the API to save the changed order
try {
  const response = await axios.post(
    `${API_BASE_URL}/steps/reorder`,
    {
      meeting_id: meeting?.id,
      steps: changedSteps.map((step) => ({
        id: step.id,
        order_no: step.order_no,
      })),
      _method: "post",
    },
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token") || localStorage.getItem("token")}`,
      },
    }
  );

  if (response.status === 200) {
    await refreshMeeting();
    setIsDrag(false);
  } else {
    console.error("Error updating the order");
  }
} catch (error) {
  console.error("API call failed:", error);
  setIsDrag(false);
}
  }


  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    // Update the order_no after reordering
    return result.map((item, index) => ({
      ...item,
      order_no: index + 1, // Update the order_no based on the new index
    }));
  };
  const getYoutubeEmbedUrl = (url) => {
    if (!url) {
      return false;
    }
    if (url.includes("youtube.com/watch")) {
      const videoUrl = new URL(url);
      const videoId = videoUrl.searchParams.get("v");

      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
      // Handle the shortened YouTube URL (youtu.be)
    }
    if (url.includes("youtu.be/")) {
      const videoId = url.split("youtu.be/")[1];
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }

    return false; // Return false if it's not a valid YouTube URL
  };
  const [dropdownVisible, setDropdownVisible] = useState(
    Array(data?.length).fill(true)
  );
  const dropdownRefs = useRef([]);

  const toggleDropdown = (index) => {
    return;
    setDropdownVisible((prev) => {
      const newDropdownVisible = [...prev];
      newDropdownVisible[index] = !newDropdownVisible[index];
      return newDropdownVisible;
    });
  };
  useEffect(() => {
    data?.forEach((item, index) => {
      const el = dropdownRefs.current[index];
      if (el) {
        if (dropdownVisible[index]) {
          el.style.display = "block";
          requestAnimationFrame(() => {
            el.classList.add("show");
          });
        } else {
          el.classList.remove("show");
          el.addEventListener(
            "transitionend",
            () => {
              el.style.display = "none";
            },
            { once: true }
          );
        }
      }
    });
  }, [dropdownVisible, data]);

  useEffect(() => {
    const currentInProgressStep = data?.find(
      (item) => item.step_status === "in_progress"
    );
    setInProgressStep(currentInProgressStep || null);
  }, [data]);

  // Fetch Excel data when inProgressStep changes
  useEffect(() => {
    const fetchExcel = async () => {
      if (inProgressStep?.editor_type === "Excel" && inProgressStep?.file) {
        try {
          const fileResponse = await axios.get(
            `${Assets_URL}/${inProgressStep.file}`,
            {
              responseType: "arraybuffer",
            }
          );

          const fileData = fileResponse.data;
          const workbook = read(fileData, { type: "buffer" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonSheetData = utils.sheet_to_json(worksheet, { header: 1 });

          const formattedData = jsonSheetData.map((row, rowIndex) =>
            row.map((cell) => ({
              value: cell,
              readOnly: rowIndex === 0,
            }))
          );

          setExcelData(formattedData);
        } catch (error) {
          console.error("Error fetching Excel file:", error);
        }
      }
    };

    if (inProgressStep) {
      fetchExcel();
    }
  }, [inProgressStep]);

  const fetchExcelData = async (file) => {
    if (file) {
      try {
        const response = await fetch(`${Assets_URL}/${file}`, {
          method: "GET",
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const fileData = await response.arrayBuffer();
        const workbook = read(fileData, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonSheetData = utils.sheet_to_json(worksheet, { header: 1 });

        const formattedData = jsonSheetData.map((row, rowIndex) =>
          row.map((cell) => ({
            value: cell,
            readOnly: rowIndex === 0,
          }))
        );

        setExcelData(formattedData);
      } catch (error) {
        console.error("Error fetching Excel file:", error);
      }
    }
  };

  const sanitizeContent = (content) => {
    if (!content) return null;

    const sanitizedContent = DOMPurify.sanitize(content, {
      ADD_TAGS: [
        "table",
        "tr",
        "td",
        "th",
        "tbody",
        "thead",
        "tfoot",
        "caption",
        "iframe",
      ],
      ADD_ATTR: [
        "allow",
        "allowfullscreen",
        "frameborder",
        "scrolling",
        "src",
        "title",
        "style",
      ],
    });

    // Create a temporary div to hold the sanitized HTML and parse it
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = sanitizedContent;

    // Find all iframe tags within the content
    const iframes = tempDiv.querySelectorAll("iframe");

    // Replace each iframe tag with a link while preserving its surrounding structure
    iframes.forEach((iframe) => {
      const iframeSrc = iframe.getAttribute("src");

      if (iframeSrc) {
        const linkElement = document.createElement("a");
        linkElement.href = iframeSrc;
        linkElement.target = "_blank";

        // Create a more user-friendly link text (optional improvement)
        // linkElement.textContent = `Click here to view the content`;
        linkElement.textContent = iframeSrc;

        // Apply the truncation class to the link element
        linkElement.classList.add("truncated-link");
        // Replace iframe with the link while keeping it inside the parent tag (e.g., table, td)
        iframe.parentNode.replaceChild(linkElement, iframe);
      }
    });

    // Return the updated HTML as a string
    return tempDiv.innerHTML;
  };

  const [openCompletedStep, setOpenCompletedStep] = useState(null); // Track the open completed step

  return (

    <StepCounterContextProvider>
      <Suspense fallback={<div>Loading...</div>}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="steps">
            {(provided) => (
              <div
                className="row"
                style={{ marginBottom: "3rem", gap: "4px" ,
                  opacity: isDrag ? 0.5 : 1,
                  pointerEvents: isDrag ? "none" : "auto",
                }}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {data?.map((item, index) => {
                  let editorContent = item.editor_content;
                  const tempDiv = document.createElement("div");
                  tempDiv.innerHTML = editorContent;
                  const firstImageTag = tempDiv.querySelector("img");
                  const firstImageUrl = firstImageTag
                    ? firstImageTag.getAttribute("src")
                    : "";

                  const handleClick = (item, index) => {
                    if (loading) return;
                    setLoading(true);
                    // const selectedStep = data?.steps[index];
                    if (item?.step_status === "completed") {
                      if (item?.editor_type === "Excel") {
                        fetchExcelData(item?.file);
                      }
                      navigate(`/step/${item?.id}`, {
                        state: { meeting: meeting },
                      });
                    } else if (item?.step_status === "in_progress") {
                      changeStatusAndPlay(meeting, item);
                      toggle(true);
                    } else if (item?.step_status === "todo") {
                      navigate(`/step/${item?.id}`, {
                        state: { meeting: meeting },
                      });
                    } else {
                      navigate(`/step/${item?.id}`, {
                        state: { meeting: meeting },
                      });
                    }
                    setTimeout(() => setLoading(false), 2000); // Adjust the delay if necessary
                  };

                  return (
                        <Draggable
                          key={item.id}
                          draggableId={item.id.toString()}
                          index={index}
                          isDragDisabled={
                            item.step_status === "in_progress" ||
                            item.step_status === "completed" 
                          }
                        >
                          {(provided) => (
                            <div
                              className="col-12 ste"
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              key={index}
                            >
                              <Card
                                className="mt-4 step-card-meeting"
                                onClick={() => {
                                  // toggle(false);
                                  handleClick(item, index);
                                }}
                              >
                                <Card.Body className="step-card-body">
                                  <div className="step-number-container">
                                    <span className="step-number">
                                      {item?.order_no <= 9 ? "0" : " "}
                                      {item?.order_no}
                                    </span>
                                  </div>
                                  <div className="step-body">
                                    <div className="step-data stepcard-stepdata">
                                      <div className="step-header">
                                        <Card.Title className="step-card-heading">
                                          {item?.title}
                                        </Card.Title>
                                        {!window.location.href.includes(
                                          "/present/invite"
                                        ) &&
                                          // meeting.status === "in_progress" &&
                                          (item.step_status === "completed" ? (
                                            <span className="status-badge-completed">
                                              {/* Completed */}
                                              {t("badge.completed")}
                                            </span>
                                          ) : item.step_status ===
                                            "in_progress" ? (
                                            <span
                                              className={
                                                convertTimeTakenToSeconds(
                                                  item?.time_taken
                                                ) >
                                                  convertCount2ToSeconds(
                                                    item?.count2,
                                                    item?.time_unit
                                                  )
                                                  ? "status-badge-red"
                                                  : "status-badge-inprogress"
                                              }
                                            >
                                              {t("badge.inprogress")}
                                            </span>
                                          ) : item.step_status === "to_finish" ? (
                                            <span
                                              className={"status-badge-finish"}
                                            >
                                              {t("badge.finish")}
                                            </span>
                                          ) : item?.step_status ===
                                            "cancelled" ? (
                                            <span
                                              className={"status-badge-cancel"}
                                            >
                                              {t("badge.cancel")}
                                            </span>
                                          ) : item?.step_status === "todo" ? (
                                            // null
                                            <span className="status-badge-green">
                                              {t("badge.todo")}
                                            </span>
                                          ) : (
                                            // null
                                            <span className="status-badge-upcoming">
                                              {t("badge.future")}
                                              {/* Upcoming */}
                                            </span>
                                          ))}
                                      </div>
                                      <div className="step-content">
                                        <Card.Subtitle className="step-card-subtext">
                                          {meeting?.newsletter_guide ? (
                                            <>
                                              {meeting?.newsletter_guide?.logo ? (
                                                <img
                                                  height="24px"
                                                  width="24px"
                                                  style={{
                                                    marginRight: "9px",
                                                    borderRadius: "20px",
                                                    objectFit: "cover",
                                                    objectPosition: "top",
                                                  }}
                                                  src={meeting?.newsletter_guide?.logo?.startsWith('http') ? meeting?.newsletter_guide?.logo :
                                                    Assets_URL +
                                                    "/" +
                                                    meeting?.newsletter_guide?.logo
                                                  }
                                                  alt={
                                                    meeting?.newsletter_guide?.name
                                                  }
                                                />
                                              ) : (
                                                <HiUserCircle
                                                  style={{
                                                    height: "24px",
                                                    width: "24px",
                                                  }}
                                                />
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {item?.image || item?.assigned_to_image ? (
                                                <img
                                                  height="24px"
                                                  width="24px"
                                                  style={{
                                                    marginRight: "9px",
                                                    borderRadius: "20px",
                                                    objectFit: "cover",
                                                    objectPosition: "top",
                                                  }}
                                                  src={
                                                    item?.image?.startsWith("users/")
                                                      ? `${Assets_URL}/${item.image}`
                                                      : item?.assigned_to_image?.startsWith("users/")
                                                      ? `${Assets_URL}/${item.assigned_to_image}`
                                                      : item?.image || item?.assigned_to_image // Fallback to raw URL if no prefix
                                                  }
                                                  // src={
                                                  //     item?.assigned_to_image
                                                  // }
                                                  alt="img"
                                                />
                                              ) : (
                                                <img
                                                  height="24px"
                                                  width="24px"
                                                  style={{
                                                    marginRight: "9px",
                                                    borderRadius: "20px",
                                                    objectFit: "cover",
                                                    objectPosition: "top",
                                                  }}
                                                  // src={`${users?.participant_image}`}
                                                  // src={
                                                  //   // users?.image
                                                  //   //   ? Assets_URL + "/" + users.image
                                                  //     // :
                                                  //      users?.participant_image
                                                  // }
                                                  src={
                                                    users?.image?.startsWith(
                                                      "users/"
                                                    )
                                                      ? Assets_URL +
                                                      "/" +
                                                      users?.image
                                                      : users?.image
                                                  }
                                                  alt="img"
                                                />
                                              )}
                                            </>
                                          )}

                                          {meeting?.newsletter_guide ? (
                                            <span>
                                              {meeting?.newsletter_guide?.name}
                                            </span>
                                          ) : (
                                            <span>
                                              {item?.assigned_to_name ||
                                                `${users?.firstName} ${users?.lastName}`}
                                            </span>
                                          )}
                                        </Card.Subtitle>
                                        <Card.Text className="step-card-content flex-row align-items-center card-text gap-0">
                                          <img
                                            height="16px"
                                            width="16px"
                                            src="/Assets/ion_time-outline.svg"
                                          />
                                          {window.location.href.includes(
                                            "/present/invite"
                                          ) ? (
                                            <>
                                              <span className="me-2">
                                                {item?.step_time}
                                              </span>
                                            </>
                                          ) : (
                                            <span
                                              className={`${item?.time_unit === "days"
                                                ? "me-2"
                                                : "me-2"
                                                }`}
                                            >
                                              {item?.time_unit === "days" ? (
                                                <>
                                                  {item.step_status === null ||
                                                    item?.step_status === "todo"
                                                    ? formatStepDate(
                                                      item?.start_date,
                                                      item?.step_time,

                                                      meeting?.timezone
                                                    )
                                                    : formatStepDate(
                                                      item?.start_date,
                                                      item?.step_time,
                                                      meeting?.timezone
                                                    )}
                                                </>
                                              ) : (
                                                <>
                                                  {item?.step_status === null ||
                                                    item?.step_status === "todo"
                                                    ? formatStepDate(
                                                      item?.start_date,
                                                      item?.step_time,
                                                      meeting?.timezone
                                                    ) +
                                                    " " +
                                                    ` ${t("at")}` +
                                                    " " +
                                                    convertTo24HourFormat(
                                                      item?.step_time,
                                                      item?.start_date,
                                                      item?.time_unit,
                                                      meeting?.timezone
                                                    )
                                                    : formatStepDate(
                                                      item?.start_date,
                                                      item?.step_time,
                                                      meeting?.timezone
                                                    ) +
                                                    " " +
                                                    ` ${t("at")}` +
                                                    " " +
                                                    convertTo24HourFormat(
                                                      item?.step_time,
                                                      item?.start_date,
                                                      item?.time_unit,
                                                      meeting?.timezone
                                                    )}
                                                </>
                                              )}
                                            </span>
                                          )}{" "}
                                        </Card.Text>
                                        <Card.Text className="step-card-content flex-row align-items-center gap-0 mb-3">
                                          <span className="">
                                            <img
                                              height="16px"
                                              width="16px"
                                              src="/Assets/alarm-invite.svg"
                                            />
                                          </span>
                                          {window.location.href.includes(
                                            "/present/invite"
                                          ) ? (
                                            <span>
                                              {localizeTimeTaken(
                                                item?.time_taken?.replace(
                                                  "-",
                                                  ""
                                                )
                                              )}
                                            </span>
                                          ) : (
                                            <>
                                              {item?.step_status === null ||
                                                item?.step_status === "todo"
                                                ? item.count2 +
                                                " " +
                                            `${  getTimeUnitDisplay(item?.count2, item?.time_unit, t)}`
                                                : item?.step_status === "to_finish" ? 
                                                formatPauseTime(
                                                  item?.work_time,t
                                                )
                                                : localizeTimeTakenActive(
                                                  item?.time_taken?.replace(
                                                    "-",
                                                    ""
                                                  )
                                                )}
                                              {item?.step_status !== null &&
                                                item?.step_status !==
                                                "todo" && (
                                                  <span>
                                                    &nbsp; /{" "}
                                                    {item.count2 +
                                                      " " +
                                                 `${  getTimeUnitDisplay(item?.count2, item?.time_unit, t)}`
                                                    }
                                                  </span>
                                                )}
                                            </>
                                          )}{" "}
                                        </Card.Text>
                                      </div>
                                    </div>
                                    <div className="step-images">
                                      {item.editor_content &&
                                        item.editor_content.trim() !==
                                        "<html><head></head><body></body></html>" ? (
                                        <div className="step-img-container">
                                          {firstImageUrl ? (
                                            <Card.Img
                                              className="step-img report-step-img"
                                              src={firstImageUrl}
                                            />
                                          ) : (
                                            <div className="fallback-img-container">
                                              {/* <img
                                src="/Assets/Tek.png"
                                className="fallback-img"
                                alt="Fallback Image"
                              /> */}
                                              <FiEdit
                                                className="file-img img-fluid"
                                                style={{ padding: "12px" }}
                                              />
                                            </div>
                                          )}
                                        </div>
                                      ) : item.editor_type === "File" ? (
                                        <div className="file-img-container">
                                          <PiFilePdfLight
                                            className="file-img img-fluid"
                                            style={{ padding: "12px" }}
                                          />
                                        </div>
                                      ) : item.editor_type === "Excel" ? (
                                        <div className="file-img-container">
                                          <RiFileExcel2Line
                                            className="file-img img-fluid"
                                            style={{ padding: "14px" }}
                                          />
                                        </div>
                                      ) : item.editor_type === "Video" ? (
                                        <div className="file-img-container">
                                          <IoVideocamOutline
                                            className="file-img img-fluid"
                                            style={{ padding: "12px" }}
                                          />
                                        </div>
                                      ) : item.editor_type === "Photo" ? (
                                        <div className="file-img-container">
                                          <MdOutlinePhotoSizeSelectActual
                                            className="file-img img-fluid"
                                            style={{ padding: "12px" }}
                                          />
                                        </div>
                                      ) : item.url ? (
                                        <div className="link-img-container">
                                          <IoCopyOutline
                                            className="file-img img-fluid"
                                            style={{ padding: "12px" }}
                                          />
                                        </div>
                                      ) : (
                                        <div className="fallback-img-container">
                                          <FiEdit
                                            className="file-img img-fluid"
                                            style={{ padding: "12px" }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Card.Body>
                              </Card>
                            </div>
                          )}
                        </Draggable>
                    
                  );
                })}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        {isModalOpen && (
          <Suspense fallback={<div>Loading...</div>}>
            <div className="new-meeting-modal">
              <LazyStepChart
                meetingId={meeting?.id}
                id={stepId}
                show={isModalOpen}
                meeting={meeting}
                setId={setStepId}
                closeModal={handleCloseModal}
                key={`step-chart-${stepId}`}
                isDrop={isDrop}
                stepIndex={stepIndex}
                refreshMeeting={refreshMeeting}
              />
            </div>
          </Suspense>
        )}

        {visoModal && (
          <ConfirmationModal
            message={t("Do you want to open the visioconference in a new tab?")}
            onCancel={handleClose}
            onConfirm={handleConfirm}
          />
        )}
      </Suspense>
    </StepCounterContextProvider>
  );
};

export default StepCard;